import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Icon, Typography, ButtonBase, Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';

import useStyles from './styles';

const Lesson = props => {
  const classes = useStyles(props);
  const { id, isConcluded, daysToRelease, moduleId, title } = props;

  const isActive = useSelector(
    state => Number(state.course.current.lesson) === Number(id),
  );
  const [status, setStatus] = React.useState(0);
  const [icon, setIcon] = React.useState('');
  const [statusClass, setStatusClass] = React.useState('');

  React.useEffect(() => {
    if (!isConcluded && daysToRelease === 0) {
      setStatus(0);
    }
    if (isConcluded) {
      setStatus(2);
    }
    if (daysToRelease > 0) {
      setStatus(1);
    }
  }, [isConcluded, daysToRelease]);

  const handleStatusValues = newStatus => {
    switch (newStatus) {
      case 1:
        setIcon('lock');
        setStatusClass('locked');
        break;
      case 2:
        setIcon('checked');
        setStatusClass('completed');
        break;
      default:
        setIcon('');
        setStatusClass('resting');
        break;
    }
  };

  React.useEffect(() => {
    handleStatusValues(status);
  }, [status]);

  const handleLink = location => {
    const { pathname } = location;
    let targetPath = pathname.split('/');
    targetPath[targetPath.length - 1] = id;
    targetPath = targetPath.join('/');

    return {
      ...location,
      pathname: targetPath,
    };
  };

  return (
    <ButtonBase
      component={Link}
      to={location => handleLink(location)}
      className={`${classes.container} ${statusClass} ${
        isActive ? 'active' : ''
      }`}
    >
      {moduleId ? (
        <Box className="marker">
          <Box className="marker-circle" />
          <Box className="marker-line" />
        </Box>
      ) : null}
      <Box className="title">
        <Typography className="title-text" variant="caption">
          {title}
        </Typography>
      </Box>
      <Box className="icon">
        {daysToRelease ? (
          <Tooltip
            disableFocusListener
            placement="top"
            title={`Faltam ${daysToRelease} dias`}
          >
            <Icon fontSize="small" color="inherit">
              {icon}
            </Icon>
          </Tooltip>
        ) : (
          <Icon fontSize="small" color="inherit">
            {icon}
          </Icon>
        )}
      </Box>
    </ButtonBase>
  );
};

export default memo(Lesson);
